import { Upload, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { API_BASE_URL } from '../config';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import { Button } from '../components/ui';
import { PageBody, PageHead } from '../layout';

const UploadParity1Listings = () => {
  function onChange(info: UploadChangeParam<UploadFile<any>>) {
    if (info.file.status === 'done') {
      notification.success({
        message:
          'List successfully sent with ' +
          info.file.response.total.toLocaleString() +
          ' domains.',
      });
    } else if (info.file.status === 'error') {
      notification.error({ message: 'List failed to send.' });
    }
  }

  return (
    <>
      <PageHead
        title="Parity1 Listings Email"
        subtitle="Send the Parity1 listing email by uploading a file."
      />
      <PageBody>
        <div className="flex flex-col gap-4">
          <p className="text-text-2 text-[12.5px]">
            Click below to upload a file. The listing email will be sent immediately once a file
            is selected.
          </p>
          <Upload
            name="file"
            multiple={false}
            action={API_BASE_URL + '/v1/afternic/sendParity1Listings'}
            onChange={onChange}
          >
            <Button variant="primary" iconLeft={<UploadOutlined />}>
              Click to Upload
            </Button>
          </Upload>
        </div>
      </PageBody>
    </>
  );
};

export default UploadParity1Listings;
